import { camelToKebabCase, objectEntries } from "@instacover/utils"

import type { Theme } from "./types"

// Used when a customer defines no button shadow
const DEFAULT_BUTTON_SHADOW = "3px 3px 24px #00000029"
// Used when a customer defines ("unset"); a valid value keeps the tw-shadow composition intact
const NO_BUTTON_SHADOW = "0 0 #0000"

// Resolves the per-customer button shadow into a value safe for the shadow-ic-button utility
function resolveButtonShadow(buttonShadow: string | undefined): string {
  if (buttonShadow === undefined) return DEFAULT_BUTTON_SHADOW
  if (buttonShadow === "unset") return NO_BUTTON_SHADOW
  return buttonShadow
}

//Mirrors the Emotion theme into CSS variables so Tailwind utilities (bg-ic-*, text-ic-*)
//read the same colors.
export function injectThemeVariables(theme: Theme) {
  const root = document.documentElement.style

  for (const [key, value] of objectEntries(theme.colors)) {
    root.setProperty(`--ic-colors-${camelToKebabCase(key)}`, value)
  }

  root.setProperty("--ic-fonts-body", theme.fonts.body)
  root.setProperty("--ic-fonts-heading", theme.fonts.heading)
  root.setProperty("--ic-radius-primary", theme.borderRadius)

  root.setProperty("--ic-shadow-button", resolveButtonShadow(theme.shadows?.button))
}
